import AutocompleteField from 'components/forms/fields/autocomplete-field/autocomplete-field.component';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const AmountTypeSelect = ({ name, orderData }) => {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const onChange = (e, value) => {
    setValue(name, value.id);
    if (value.id === 'fullAmount') {
      setValue('refundAmount', orderData?.orderTotal?.displayTotal, {
        shouldValidate: true,
      });
    }
  };

  const options = [
    {
      id: 'fullAmount',
      label: t(
        'forms.fields.refundForm.amountTypeSelect.options.fullAmount.label',
      ),
    },
    {
      id: 'partialAmount',
      label: t(
        'forms.fields.refundForm.amountTypeSelect.options.partialAmount.label',
      ),
    },
  ];

  return (
    <AutocompleteField
      isOptionEqualToValue={(option, value) => option?.id === value}
      name={name}
      disableClearable
      defaultValue={options[0]}
      data-testid="RefundForm.AmountTypeSelect"
      options={options}
      onChange={onChange}
      TextFieldProps={{
        label: t('forms.fields.refundForm.amountTypeSelect.label'),
      }}
    />
  );
};

export default AmountTypeSelect;
